import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "col-9 text-ellipsis" }

import { computed, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminRunDetailsPage } from '@Integrations/Runs/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminRunDetailsPage',
  setup(__props) {

    const router = useRouter()
    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        useRunDetailsQuery,
        useDeleteRunCommand,
        usePermanentDeleteRunCommand,
    } = useAdminRunDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelRunDetailsQueryV1, runRunDetailsQueryV1 } = useRunDetailsQuery(tid, id, true)
    const pipelineName = computed(() => modelRunDetailsQueryV1.value?.PipelineName || [])
    const log = computed(() => modelRunDetailsQueryV1.value?.Log || [])
    const isDeleted = computed(() => modelRunDetailsQueryV1.value?.IsDeleted)

    const { invokeDeleteRunCommandV1, succeedDeleteRunCommandV1 } = useDeleteRunCommand(id, tid, userId)
    const { invokePermanentDeleteRunCommandV1, succeedPermanentDeleteRunCommandV1 } = usePermanentDeleteRunCommand(id)

    onMounted(() => {
        runCurrentUserQueryV1()
        runRunDetailsQueryV1()
    })

    watch(succeedDeleteRunCommandV1, () => runRunDetailsQueryV1())

    watch(succeedPermanentDeleteRunCommandV1, (val) => val ? router.push(`/admin/integrations/runs/manage/${tid}`) : null)

    function handleDeleteRunCommandV1() {
        if (confirm(`Do you really want to delete run ${id}?`)) invokeDeleteRunCommandV1()
    }

    function handlePermanentDeleteRunCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete run ${id}?`)) invokePermanentDeleteRunCommandV1()
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(pipelineName.value), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/integrations/runs/manage/${_unref(tid)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_6),
          (!isDeleted.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: handleDeleteRunCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */),
                _createTextVNode(" Delete ", -1 /* CACHED */)
              ]))]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: handlePermanentDeleteRunCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", {
                  class: "fa fa-remove",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Permanently delete ", -1 /* CACHED */)
              ]))]))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-4 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.value, (line) => {
        return (_openBlock(), _createElementBlock("div", {
          title: line.Message,
          class: "row"
        }, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(line.OccuredAt), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_10, _toDisplayString(line.Message), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_8))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

})